module.exports = __webpack_public_path__ + "media/customizations/beaumont/logo-51177c86af14b3bfba695f6d056a43f9.png";